import { PRODUCT_TYPE_ID } from '../constants/ObjectTypeIds';
import { isMultiCurrencyPrice } from '../property/PropertyIdentifier';
import { isPricingModelTiered } from './Pricing';
export const isReadOnlyProductProperty = (objectTypeId, property, getAdditionalPropertyValues) => {
  if (objectTypeId !== PRODUCT_TYPE_ID || !property.hubspotDefined) {
    // if objectTypeId is not a product or it's a custom property, it should be editable
    return false;
  }
  if (property.name === 'hs_pricing_model') {
    return true;
  }
  if (isMultiCurrencyPrice(property) || property.name === 'price') {
    const pricingModel = getAdditionalPropertyValues === null || getAdditionalPropertyValues === void 0 ? void 0 : getAdditionalPropertyValues('hs_pricing_model');
    if (isPricingModelTiered(pricingModel)) {
      return true;
    }
    return false;
  }
  return false;
};